<template>
  <div class="pay_cont creditCard target_creditcard">
    <div class="row card-method" v-if="!financeName">
      <div class="sub-title-area card_benefit-area">
        <span class="sstit">신용/체크카드</span>
      </div>
      <div class="payment-item-a-btn">
        <button type="button" class="bt-akl-white basic st2" @click="openXpay">
          <span>+</span>카드정보 등록
        </button>
      </div>
    </div>
    <div class="row card-method" v-if="financeName">
      <div class="payment-item-a-btn">
        <div class="payment-item-title-bar">
          <span class="payment-item-title">결제카드</span>
          <span class="payment-item-title">{{ financeName }}</span>
        </div>
        <button type="button" class="bt-akl-white basic st2" @click="openXpay">
          카드정보 변경
        </button>
      </div>
    </div>
    <form method="post" id="LGD_PAYINFO" name="LGD_PAYINFO">
      <input
        type="hidden"
        id="CST_PLATFORM"
        name="CST_PLATFORM"
        :value="cardBillingConfig.cstPlatform"
      />
      <input
        type="hidden"
        id="CST_MID"
        name="CST_MID"
        :value="cardBillingConfig.cstMid"
      />
      <input
        type="hidden"
        id="LGD_WINDOW_TYPE"
        name="LGD_WINDOW_TYPE"
        :value="isMobile ? 'submit' : 'iframe'"
      />
      <input
        type="hidden"
        id="LGD_MID"
        name="LGD_MID"
        :value="cardBillingConfig.lgdMid"
      />
      <input type="hidden" id="LGD_BUYERSSN" name="LGD_BUYERSSN" value="" />
      <input
        type="hidden"
        id="LGD_CHECKSSNYN"
        name="LGD_CHECKSSNYN"
        value="N"
      />
      <input
        type="hidden"
        id="LGD_PRODUCTINFO"
        name="LGD_PRODUCTINFO"
        value=""
      />
      <input type="hidden" id="LGD_AMOUNT" name="LGD_AMOUNT" value="" />
      <input
        type="hidden"
        id="LGD_EASYPAY_ONLY"
        name="LGD_EASYPAY_ONLY"
        value=""
      />
      <input
        type="hidden"
        id="LGD_RETURNURL"
        name="LGD_RETURNURL"
        :value="returnUrl"
      />
      <input
        type="hidden"
        id="LGD_PAYWINDOWTYPE"
        name="LGD_PAYWINDOWTYPE"
        :value="isMobile ? 'CardBillingAuth_smartphone' : 'CardBillingAuth'"
      />
      <input
        type="hidden"
        id="LGD_VERSION"
        name="LGD_VERSION"
        :value="
          isMobile ? 'JSP_SmartXPay_CardBilling' : 'JSP_Non-ActiveX_CardBilling'
        "
      />
      <input
        type="hidden"
        id="LGD_ENCODING"
        name="LGD_ENCODING"
        value="UTF-8"
      />
      <input
        type="hidden"
        id="LGD_ENCODING_NOTEURL"
        name="LGD_ENCODING_NOTEURL"
        value="UTF-8"
      />
      <input
        type="hidden"
        id="LGD_ENCODING_RETURNURL"
        name="LGD_ENCODING_RETURNURL"
        value="UTF-8"
      />
      <input
        type="hidden"
        id="CUSTOM_DEVICE_TYPE"
        name="CUSTOM_DEVICE_TYPE"
        :value="isMobile ? 'mobile' : 'desktop'"
      />

      <!--
        <%-- Return URL에서 인증 결과 수신 시 셋팅될 파라미터 입니다. --%>
        <input type="hidden" name="LGD_RESPCODE" value=""/>
        <input type="hidden" name="LGD_RESPMSG" value=""/>
        <input type="hidden" name="LGD_BILLKEY" value=""/>
        <input type="hidden" name="LGD_PAYTYPE" value=""/>
        <input type="hidden" name="LGD_PAYDATE" value=""/>
        <input type="hidden" name="LGD_FINANCECODE" value=""/>
        <input type="hidden" name="LGD_FINANCENAME" value=""/>
      </c:if>
      -->
    </form>
    <modal-alert ref="refAlert" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { log } from "@/utils/common";
import ModalAlert from "@/components/global/ModalAlert";
import orderApi from "@/apis/order";
import { BILLING_PAYMENT_MODE, NORMAL_PAYMENT_METHODS } from "@/utils/constants";

export default {
  name: "CreditCardBilling",
  components: {
    ModalAlert,
  },
  async mounted() {
    window.billingKey = this;
    this.loadXpayScript();
    this.fetchBillingConfig();

    const { paymentMode, paymentCode, issuerCode, issuerName } =
      this.paymentInfo;

    if (paymentMode == NORMAL_PAYMENT_METHODS.CREDIT_CARD) {
      // mobile billingkey response
      const uuid = this.$route.query.uuid;
      if (uuid) {
        // console.log("response : " + this.$route.path);

        // this.$router.replace(this.$route.path);
        // const savedState = sessionStorage.getItem('vuex');
        // if (savedState) {
        //   this.$store.replaceState(JSON.parse(savedState));
        //   sessionStorage.removeItem('vuex');
        // }
        log("CreditCardBilling : ", uuid);
        this.$router.replace(this.$route.path);
        const resultData = await orderApi.getBillingKeyInfo(uuid);
        // 결과값 반환
        this.saveBillingKeyData(resultData);
      } else {
        this.setCreditCardBillingInfo({
          billingKey: paymentCode,
          financeCode: issuerCode,
          financeName: issuerName,
        });
      }
    }
  },

  data() {
    return {
      isMobile: "ontouchstart" in document.documentElement,
      cardBillingConfig: {},
      lgdwin: null, // iFrame (Desktop 에서만 사용)
      callback: null, // function (Desktop, Mobile 둘다 사용)
      resultData: null,
    };
  },
  computed: {
    ...mapGetters({
      paymentInfo: "payment/paymentInfo",
    }),
    financeName() {
      return this.resultData && this.resultData.financeName;
    },
    returnUrl() {
      return `${process.env.API_BASE_URL}/billing-key/receive/${
        this.isMobile ? "mobile" : "desktop"
      }`;
    },
  },
  methods: {
    async loadXpayScript() {
      const script = document.createElement("script");
      script.src =
        "https://xpay.tosspayments.com/xpay/js/xpay_crossplatform.js";
      script.onload = () => {
        log("CreditCardBilling::load xpay js");
      };
      document.head.appendChild(script);
    },
    async fetchBillingConfig() {
      const params = { payment_mode: BILLING_PAYMENT_MODE.CREDIT_CARD };
      const result = await orderApi.getPaymentConfig(params);
      if (result.error) {
        return;
      }
      this.cardBillingConfig = result;
    },
    openXpay() {
      const lgdPayInfo = document.getElementById("LGD_PAYINFO");
      const cstPlatform = document.getElementById("CST_PLATFORM").value;
      const lgdWindowType = document.getElementById("LGD_WINDOW_TYPE").value;

      if (this.isMobile) {
        sessionStorage.setItem("billingCallbackUrl", window.location.href);

        // store 저장
        const stateCopy = { ...this.$store.state };
        delete stateCopy.appReadyState; // appReadyState 제외
        sessionStorage.setItem("save-vuex", JSON.stringify(stateCopy));

        this.$emit("save-data");

        // data 저장

        open_paymentwindow(lgdPayInfo, cstPlatform, lgdWindowType);
      } else {
        this.lgdwin = openXpay(lgdPayInfo, cstPlatform, lgdWindowType);
      }
    },
    sendBillingKeyData() {
      const lgdwin = this.lgdwin; // iframe
      const fDoc = lgdwin.contentWindow || lgdwin.contentDocument; // document in iframe

      const resultData = {};
      resultData.respCode = fDoc.document.getElementById("LGD_RESPCODE").value;
      resultData.respMsg = fDoc.document.getElementById("LGD_RESPMSG").value;
      resultData.billingKey = fDoc.document.getElementById("LGD_BILLKEY").value;
      resultData.financeCode =
        fDoc.document.getElementById("LGD_FINANCECODE").value;
      resultData.financeName =
        fDoc.document.getElementById("LGD_FINANCENAME").value;

      // 빌링키 팝업 close()
      closeIframe();

      // 결과값 반환
      this.saveBillingKeyData(resultData);
    },
    saveBillingKeyData(resultData) {
      // 정상적으로 빌링키를 발급받았을 경우
      if (resultData.respCode == "0000") {
        this.setCreditCardBillingInfo(resultData);
        this.$refs.refAlert.openWithMessage("결제정보가 입력되었습니다.");
        return;
      }
      // 오류 발생 시 받은 결과 메시지를 노출
      else if (resultData && resultData.respMsg) {
        this.$refs.refAlert.openWithMessage(resultData.respMsg);
      }
    },
    setCreditCardBillingInfo(resultData) {
      this.resultData = resultData;
      this.$store.commit(
        "creditcardbilling/setCreditCardBillingInfo",
        resultData
      );
    },
  },
};
</script>